import React, { useCallback, useEffect } from 'react';

import { HealthPlanRenewal, RenewalDeductibleConfig } from '@/modules/Renewals/renewals.types';

import useEditAmountsForm from './hooks/useEditAmountsForm';
import { EditAmountsModal } from './components';
import { EditAmountsFormValues } from './EditAmountsModal.types';

interface Props {
  visible: boolean;
  healthPlan: HealthPlanRenewal;
  planYearDates: string;
  onClose: () => void;
  onSave: (values: EditAmountsFormValues) => void;
  originalDeductibleConfigs?: RenewalDeductibleConfig[];
}

const EditAmountsModalContainer: React.FC<Props> = ({
  visible,
  healthPlan,
  planYearDates,
  onClose,
  onSave,
  originalDeductibleConfigs,
}) => {
  const { methods, buildDefaultValues } = useEditAmountsForm(healthPlan);

  useEffect(() => {
    if (visible) {
      methods.reset(buildDefaultValues(healthPlan));
    }
  }, [visible, healthPlan, methods, buildDefaultValues]);

  const handleSave = useCallback(() => {
    methods.handleSubmit((values) => {
      onSave(values);
    })();
  }, [methods, onSave]);

  const handleClose = useCallback(() => {
    onClose();
  }, [onClose]);

  if (!visible) return null;

  return (
    <EditAmountsModal
      visible={visible}
      healthPlan={healthPlan}
      planYearDates={planYearDates}
      methods={methods}
      onClose={handleClose}
      onSave={handleSave}
      originalDeductibleConfigs={originalDeductibleConfigs}
    />
  );
};

export default EditAmountsModalContainer;
